module.exports = __webpack_public_path__ + "static/Burst_6s-44fffb8aa2133c7b14206c34e0d6a661.jpg";